<div class="dynamic-forms-container mx-auto">
  <div class="header-section">
    <h1>Your Forms</h1>
    <p>Manage your dynamic forms and view responses.</p>
  </div>

  <div class="forms-grid">
    <!-- Create New Form Card -->
    <div class="create-card" (click)="createNewForm()">
      <div class="dashed-border">
        <div class="icon-circle">
          <i class="pi pi-plus"></i>
        </div>
        <h3>Create New Form</h3>
        <span>Start from scratch</span>
      </div>
    </div>

    <!-- Existing Forms Cards -->
    <ng-container *ngFor="let form of forms$ | async">
      <div class="form-card">
        <div class="card-header">
           <div class="icon-file">
             <i class="pi pi-file"></i>
           </div>
           <div class="actions">
             <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" (onClick)="editForm(form.id)" pTooltip="Edit"></p-button>
             <p-button *ngIf="form.isActive" icon="pi pi-eye-slash" [rounded]="true" [text]="true" severity="warning" (onClick)="toggleStatus($event, form)" pTooltip="Deactivate"></p-button>
             <p-button *ngIf="!form.isActive" icon="pi pi-eye" [rounded]="true" [text]="true" severity="success" (onClick)="toggleStatus($event, form)" pTooltip="Activate"></p-button>
           </div>
        </div>
        <div class="card-body">
          <div class="flex flex-column gap-2">
            <h3>{{ form.name }}</h3>
            <span class="text-sm text-gray-500" *ngIf="form.version">Version: {{ form.version }}</span>
          </div>
          <span class="date">{{ form.updatedAt | date:'mediumDate' }}</span>
        </div>
        <div class="card-footer">
          <div class="status" [ngClass]="form.isActive ? 'status-active' : 'status-inactive'">
            <span class="dot" [style.background-color]="form.isActive ? 'var(--green-500)' : 'var(--orange-500)'"></span>
            <span>{{ form.isActive ? 'Active' : 'Inactive' }}</span>
          </div>
          <div class="responses">
             <span class="badge">0 Responses</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
